<template>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-if="props.showModal" class="modal-overlay">
        <div class="modal">
            <h3>SELECIONAR ESTABELECIMENTO</h3>

            <div class="row">
                <div class="form-item">
                    <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                    <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
                </div>
                <button type="button" class="buttom-icon--close" @click="closeModal" />
            </div>



            <div class="table-scroll table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>SIM</th>
                            <th>Nome</th>
                            <th>Atividade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(obj, index) in lsDados" :key="obj.id" @click="selecionarRegistro(obj)"
                            :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                        >
                            <td class="col-width-char30">{{ obj.nmsim }}</td>
                            <td>{{ obj.nmestabelecimento }}</td>
                            <td class="col-width-char50"  style="font-size: 0.9em;">{{ obj.nmatividade }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="result-info">
                {{ lsDados.length }} registro(s) encontrado(s)
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const props = defineProps({ showModal: { type: Boolean, required: true } });
const emit = defineEmits(['close', 'objSelecionado']);

const lsDados = ref([]);
const lsDadosFull = ref([]);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);

async function pesquisar() {
    try {
        msgAlerta.value = null;

        const req = await Api.genericPost('/listas/estabelecimentos', {
            idep: globalStore.idep,
            idsim: (globalStore.ckperfilinspetor) ? globalStore.idsim : null,
            ativo: "S"
        });

        lsDadosFull.value = req || [];
        filtrarDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }
}

function normalizarTexto(value) {
    return (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .trim();
}

function filtrarDados() {
    const filtro = normalizarTexto(nmPesquisa.value);

    if (!filtro) {
        lsDados.value = [...lsDadosFull.value];
        return;
    }

    lsDados.value = lsDadosFull.value.filter(obj => {
        const nome = normalizarTexto(obj.nmestabelecimento);
        const fantasia = normalizarTexto(obj.nmfantasia);
        const sim = normalizarTexto(obj.nmsim);
        const atividade = normalizarTexto(obj.nmatividade);
        const cpfcnpj = normalizarTexto(obj.cpfcnpj);

        return (
            nome.includes(filtro) ||
            fantasia.includes(filtro) ||
            sim.includes(filtro) ||
            atividade.includes(filtro) ||
            cpfcnpj.includes(filtro)
        );
    });
}

const selecionarRegistro = (obj) => {
    emit('objSelecionado', obj);
    closeModal();
}

const closeModal = () => {
    emit('close');
}

watch(nmPesquisa, filtrarDados);

onMounted(pesquisar);
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: white;
    padding: 10px;
    border-radius: 8px;
    height: 450px;
    display: flex;
    flex-direction: column;
    max-width: 850px;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.result-info {
    margin-top: 8px;
    font-size: 12px;
    color: #64748b;
    text-align: left;
}

.table-scroll {
    flex: 1;
    overflow-y: auto;
    margin-top: 10px;
}
.table-scroll thead th {
    position: sticky;
    top: 0;
    background: #c1d7d6;
    z-index: 1;
}
</style>
  